module.exports = __webpack_public_path__ + "static/media/ehealth_health_coins_redemption_banner_desktop.5edbb0cb.jpg";